module.exports = __webpack_public_path__ + "static/img/banner-plantas.28afe01.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/nuestra-empresa-en/banner-plantas.jpg
// module id = 4nLF
// module chunks = 0